var React = require('react');

function TrashIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M7,20.06A2,2,0,0,0,9,22h6a2,2,0,0,0,2-1.94L18,8H6Z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M18.88,3.44H16.49A1.49,1.49,0,0,0,15,2H9A1.49,1.49,0,0,0,7.51,3.44H5.12A1.13,1.13,0,0,0,4,4.57V6.45H20V4.57A1.13,1.13,0,0,0,18.88,3.44Z","key":1})]);
}

TrashIcon.defaultProps = {"data-dmid":"dm-trash-icon","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = TrashIcon;

TrashIcon.default = TrashIcon;
